<template>
  <label class="ml-base">
    <div
      class="font-bold mb-xs"
      :class="{ 'cursor-pointer': !!$attrs.for }">
      {{ label }}
    </div>
    <div
      class="font-normal"
      :class="{ 'cursor-pointer': !!$attrs.for }">
      <slot />
    </div>
  </label>
</template>

<script>
export default {
  name: 'SequenceLabel',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>
